// extracted by mini-css-extract-plugin
module.exports = {"lines":"MinimumRequirements_lines__2EeAP"};